export { default } from './EzInput.vue';
